export const BooleanUI: { [key: string]: string } = {
    true: 'Yes',
    false: 'No',
};

export type PromiseResolve<T> = (value: T) => void;
